import React, { useContext, useState } from "react"
import { Grid } from '@mui/material';
import { CardTypes, ProjectSchemeInterface } from "ts-interfaces";
import { ExistingCard } from "../components/ExistingCard";
import { duplicateProjectScheme, deleteProjectScheme } from "../../v2/apis/projectsSchemeApi";
import { DeleteComponentModal } from "../components/DeleteComponentModal";
import { useMattoState } from "../../MattoState";
import { usePermissions, firebaseHelper } from "ui";
import { AuthContext } from "../../auth/Auth";

export const DisplayProjectSchemes = ({ data, setData, designFirms, teamMembers, selectedProject, setSelectedProject, setShowProjectManager, projectThumbnails, setShowCreatorModal, onProjectUpdate }) => {
    const {currentUser} = useContext(AuthContext);
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const {hasProjectAccess} = usePermissions(currentUser?.uid, firebaseHelper.db);
    const setSnackbarMessage = useMattoState((state) => state.setSnackbarMessage);

    const handleClick = (project: ProjectSchemeInterface) => {
        setShowProjectManager(true);
        setSelectedProject(project);
    }
    
    const openDeleteModal = (e,project) => {
        e.stopPropagation()
        setSelectedProject(project)
        setShowDeleteModal(true)
    }
    
    const handleDelete = async () => {
        setSnackbarMessage('Deleting project...');
        await deleteProjectScheme(selectedProject);
        
        // Use callback to properly update global state
        if (onProjectUpdate) {
            // Mark as archived and update via callback
            const archivedProject = { ...selectedProject, archive: true };
            onProjectUpdate(archivedProject, false);
        } else {
            // Fallback to local state update if no callback provided
            const newData = data.filter(d => d != selectedProject);
            setData(newData);
        }
        
        setSnackbarMessage('Project deleted successfully');
    }

    const handleCopy = async (e,project) => {
        e.stopPropagation()
        e.preventDefault()
        setSnackbarMessage('Duplicating project...');
        const duplicatedProject = await duplicateProjectScheme(project);
        
        // Use callback to properly update global state
        // The duplicated project now belongs to the current user, so it should appear in their "owned" projects
        if (onProjectUpdate) {
            onProjectUpdate(duplicatedProject, true);
        } else {
            // Fallback to local state update if no callback provided
            const newProjects = [duplicatedProject, ...data];
            setData(newProjects);
        }
        
        setSnackbarMessage('Project duplicated successfully');
    }

    const handleEdit = (project: ProjectSchemeInterface) => {
        setSelectedProject(project)
        setShowCreatorModal(true)
    }

    return (
        <>
            {data.map((project: ProjectSchemeInterface) => {
                const hasViewerAccess = (hasProjectAccess(project.id, 'read', project.owner) && !hasProjectAccess(project.id, 'write', project.owner)) || false;

                return (
                    <Grid key={project.id} item>
                        <ExistingCard 
                            data={project} 
                            type={CardTypes.Projects}
                            designFirms={designFirms} 
                            teamMembers={teamMembers} 
                            onEdit={() => handleEdit(project) }
                            onClick={() => handleClick(project) } 
                            onDelete={(e) => openDeleteModal(e,project)} 
                            onCopy={(e) => handleCopy(e,project)} 
                            hasViewerAccess={hasViewerAccess}
                        />
                    </Grid>
                )
            })}
            <DeleteComponentModal open={showDeleteModal} setOpen={setShowDeleteModal} onDelete={handleDelete} />
        </>
    );

}